import React, { useEffect } from 'react';
import { Availability } from './interfaces';
import { Link } from 'react-router-dom';
import { formatTime, formatDate, addDays, getDayOfWeek, getHours, getMonth, getDay } from './util';
import { labels } from './labels';

function getApptsInHour(h: number, props: IProps) {

    let days = props.availability.days;
    let slots = [[], [], [], [], []];
    for (let i = 0; i < days.length; i++) {
        for (let j = 0; j < days[i].slots.length; j++) {
            let slot = new Date(days[i].slots[j].start);
            if (slot.getHours() == h) {
                slots[i].push(slot);
            }
        }
    }
    return slots.map(d =>
        <td style={{ verticalAlign: "top", width: "17%" }}>{d.length === 0 ?
            <button className="btn btn-secondary btn-sm px-1 mb-1" disabled style={{ fontSize: "100%", display: "inline-block", width: "100%", backgroundColor: "#ccc", borderColor: "#ccc" }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </button>
            : d.map(s =>
                <Link to={{ pathname: "/newpatientcheck", search: `${window.location.search}&start=${s.toISOString().replace(".000", "")}` }} className="btn btn-secondary btn-sm px-1 mb-1" style={{ fontSize: "100%", display: "inline-block", width: "100%" }}>
                    {formatTime(s, true)}
                </Link>)}</td>
    );
}

interface IProps {
    availability: Availability;
    npi: string;
    prev?: string;
    next: string;
    lat?: string;
    lng?: string;
    place?: string;
    deptid: string;
    backToUrl: string;
    apptType?: string;
    reason?: string;
    clinic?: string;
    phone?: string;
    ageCutoff?: number;
    who?: string;
}

const Schedule = (props: IProps) => {
    let today = new Date();    
    let ed = formatDate(addDays(today, 120));

    return (
        <>
            {
                props.availability.nextAvailable &&
                <p className="text-center px-2"><b>{props.ageCutoff === 0 ? labels.provider.noCutoff : labels.provider.ageCutoff.replace("${ageCutoff}", "" + props.ageCutoff)}</b></p>
            }

            <table style={{ fontSize: "80%", width: "100%", textAlign: "center" }}>
                {props.availability.nextAvailable &&
                    <thead>
                        <tr>
                            <th style={{ width: "10%", textAlign: "right", paddingRight: "1em" }}>{props.prev &&
                                <Link className="btn btn-sm btn-primary" title="Previous 5 days" to={`/provider?npi=${props.npi}&date=${props.prev}&deptid=${props.deptid}&reason=${props.reason || ""}&who=${props.who}&backto=${encodeURIComponent(props.backToUrl)}` + (props.apptType ? `&apptType=${props.apptType}` : '')}>&lt;</Link>}</th>
                            {props.availability.days.map(d => (
                                <th style={{ width: "17%" }}>{getDayOfWeek(new Date(d.date))}</th>
                            ))}
                            <th style={{ width: "5%" }}>
                            {props.availability.hasFutureSlots && props.next < ed && <Link className="btn btn-sm btn-primary" title="Next 5 days" to={`/provider?npi=${props.npi}&date=${props.next}&deptid=${props.deptid}&reason=${props.reason}&who=${props.who}&backto=${encodeURIComponent(props.backToUrl)}` + (props.apptType ? `&apptType=${props.apptType}` : '')}>&gt;</Link>}
                            </th>


                        </tr>
                        <tr>
                            <th style={{ width: "10%" }}></th>
                            {props.availability.days.map(d => (
                                <th style={{ width: "17%", fontWeight: "normal" }}>{getMonth(d.date)}&nbsp;{getDay(d.date)}</th>
                            ))}
                            <th style={{ width: "5%" }}></th>
                        </tr>
                    </thead>
                }
                <tbody>
                    {!props.availability.nextAvailable &&
                        <tr>
                            <td></td>
                            <td colSpan={5} style={{ textAlign: "left" }}>
                                {labels.search.noAppointments(props.clinic, props.phone)}
                                {/* No {props.apptType === "2" ? "Virtual Visit" : "In-Person" } appointments available*/}
                            </td>
                            <td></td>
                        </tr>
                    }
                    {
                        getHours().map(h => {
                            return (<tr className="fullappt"><td style={{ verticalAlign: "top", textAlign: "right", padding: "5px 3px", fontWeight: "bold" }}>{h[1]}</td>{getApptsInHour(h[0], props)}<td></td></tr>)
                        })
                    }
                </tbody>
            </table>
        </>
    );
}

export default Schedule;